import { render, staticRenderFns } from "./timerComponent.vue?vue&type=template&id=36491dc4&scoped=true"
import script from "./timerComponent.vue?vue&type=script&lang=js"
export * from "./timerComponent.vue?vue&type=script&lang=js"
import style0 from "./timerComponent.vue?vue&type=style&index=0&id=36491dc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36491dc4",
  null
  
)

export default component.exports